import axios from 'axios';

export function  getUserId() {
  return sessionStorage.getItem("userid");
}
export function  getToken() {
  return sessionStorage.getItem("token");
}
//低速系统的文件上传接口
export function  getUploadFileStream() {
  return  axios.defaults.baseURL + "/comm/uploadFileStream";
}


//定位方式
export function  setLocationType(type) {
  return sessionStorage.setItem('locationType',type);
}
export function  getLocationType() {
  return sessionStorage.getItem('locationType');
}



// WEBPACK FOOTER //
// ./src/utils/auth.js